<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Subscription Plan</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Subscription Plan</li>
            </ol>
          </div>
        </div>
      </div><!-- /.container-fluid -->
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-header">
            <button class="btn btn-info" @click="showFilter = !showFilter" disabled>
              <i class="fa fa-filter"></i>Filter
            </button>

            <div class="card-tools">
              <router-link :to="{ name: 'SubscriptionPlanAdd'}" class="btn btn-success">
                <i class="fas fa-plus"></i> New
              </router-link>
            </div>
          </div>
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <div class="card-body p-0">
            <form @submit.prevent="getList()" method="GET" novalidate>
              <div class="card-body" v-if="showFilter">
                <div class="row">

                </div>
                <div class="row">
                  <div class="col-10 offset-1">
                    <button type="submit" class="btn btn-primary m-2px">Search</button>
                    <button type="reset" class="btn btn-warning" @click="resetFilter()">Reset</button>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div class="card-body table-responsive-md p-0">
            <table class="table">
              <thead>
              <tr>
                <th>ID</th>
                <th>Ref-Id</th>
                <th>Name</th>
                <th>Product</th>
                <th>Group</th>
                <th>Status</th>
                <th>Phase</th>
                <th>Phase Type</th>
                <th>Phase period</th>
                <th>Billing Period</th>
                <!--<th>Base Subscription Plan</th>
                <th>Upgradable Subscription Plan</th>
                <th>Downgradable Subscription Plan</th>-->
                <th class="text-right">Action</th>
              </tr>
              </thead>
              <tbody class="list">
              <tr v-for="(val, index) in list.data">
                <td>{{ val.id }}</td>
                <td>{{ val.ref_id }}</td>
                <td>{{ val.name }}</td>
                <td>{{ val.product ? val.product.bundle_title : 'NA' }}</td>
                <td>{{ val.group_name }}</td>
                <td>{{ val.status | status}}</td>
                <td>{{ val.phase }}</td>
                <td>{{ val.phase_type }}</td>
                <td>{{ val.phase_period_conf | periods }}</td>
                <td>{{ val.billing_period_conf | periods }}</td>
                <!--<td>{{ !_.isEmpty(val.ratingconditionname) ? val.ratingconditionname.name : 'NA' }}</td>
                <td>{{ !_.isEmpty(val.ratingconditionname_upgrade_plan_id) ? val.ratingconditionname_upgrade_plan_id.name : 'NA' }}</td>
                <td>{{ !_.isEmpty(val.ratingconditionname_downgrade_plan_id) ? val.ratingconditionname_downgrade_plan_id.name : 'NA' }}</td>-->
                <td class="text-right">
                  <router-link v-if="actionEdit === true" :to="{ name: 'SubscriptionPlanEdit', params: { id: val.id }}"
                               class="btn btn-info btn-sm m-2px">
                    <i class="fas fa-pencil-alt"></i>
                  </router-link>
                </td>
              </tr>
              </tbody>
            </table>
            <div class="p-4" v-if="_.isEmpty(list.data) && is_loading === false">
              <div class="alert alert-default-warning" role="alert">
                No data found!
              </div>
            </div>
          </div>
          <div class="card-footer">
            <vue-pagination :pagination="list" v-if="list.total > list.per_page" @paginate="getList()"/>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from "@/components/partials/PaginationComponent";
import {CBSSubscriptionApi} from "@/services/api";

export default {
  name: "PlanList",
  components: {
    VuePagination
  },
  data: () => ({
    list: {
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1
    },
    actionView: false,
    actionEdit: true,
    actionDelete: false,
    showFilter: false,
    filter: {},
    pre: [],
    is_loading: false,
    empty: false,
    empty_message: ''
  }),
  mounted: function () {
    this.getList()
  },
  methods: {
    getList: function () {
      this.is_loading = true
      let query = {...this.filter, ...this.$route.query}
      CBSSubscriptionApi.getPlan(query, this.list.per_page)
        .then((items) => {
          this.list = items
        })
        .finally(() => {
          this.is_loading = false
        });
    },
    resetFilter() {
      this.list.current_page = 1
      this.showFilter = false
      this.filter = {}
      this.getList()
    }
  },
  filters: {
    periods: function(value) {
      let periods = {
        '1' : "Daily",
        '2' : "Weekly",
        '3' : "Bi-Weekly",
        '4' : "Monthly",
        '5' : "Quarterly",
        '6' : "Yearly",
        '7' : "Custom"
      }
      return periods[value]
    },
    status: function(value) {
      let status = {
        '1' : 'Active', '0' : 'Inactive'
      }
      return status[value];
    }
  }
}
</script>
